import { ArrowForward, Delete, OpenInFull } from '@mui/icons-material';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { Box, Button, Card, CardContent, Divider, TextField, IconButton, Link, List, ListItem, ListItemButton, ListItemText, Skeleton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { openDialog, setData } from '../../features/dialogBox/dialogBoxSlice';
import { useSelector, useDispatch } from 'react-redux';
import GenerativeAILayout from '../CommonPage/GenerativeAILayout';

function GeneratedContentComponent({setExpanded, expanded, handleToggle, generatePromptContentLoading, generatedContentData, generatedData, ...props }) {
    console.log('a1', generatedContentData)
    console.log('a1', generatedData)
    const dispatch = useDispatch();
    const [content, setContent] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [editText, setEditText] = useState('');

    useEffect(function () {
        if (generatedContentData)
            setContent([generatedContentData, ...content]);
    }, [generatedContentData]);

    const truncateText = (text, wordLimit = 30) => {
        const words = text?.split(' ');
        if (words.length <= wordLimit) {
            return text;
        }
        return words.slice(0, wordLimit).join(' ') + '...';
    };

    const openDialogPublish = (id, data) => {
        dispatch(openDialog(id));
        dispatch(setData({ postBody: data?.prompt }));
    }

    const handleDelete = (e, positionOfItemInArray) => {
        const updatedContent = content.filter((_, index) => index !== positionOfItemInArray);
        setContent(updatedContent);
        if(updatedContent.length == 0){
            setExpanded(false)
        }
        handlePrev()
    };

    const handleEdit = (index, text) => {
        setEditIndex(index);
        setEditText(text);
    };

    const handleSave = (index) => {
        const updatedContent = content.map((item, idx) => idx === index ? { ...item, prompt: editText } : item);
        setContent(updatedContent);
        setEditIndex(null);
    };
    const [currentIndex, setCurrentIndex] = useState(0);
    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const handleNext = () => {
        if (currentIndex < content.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    return (
        <Box sx={{ height: 'calc(100vh - 64px - 37px - 36px)', overflow: 'auto' }}>
            <Card sx={{ p: 0 }}>
                <Box sx={{ backgroundColor: "#ECEFF1", p: 2 }}>
                    <Typography variant='h7' color={"#546E7A"}>Get Started</Typography>
                </Box>
                <CardContent>
                    {content.length === 0 && generatePromptContentLoading ? <Skeleton height={50} /> :
                        <>
                            {
                                content.length ?
                                    <>
                                        {generatePromptContentLoading && <Skeleton height={50} />}
                                        {content.length ?
                                            <List sx={{ py: '0px !important', pt: '1rem' }}>
                                                {content.map((data, index) => {
                                                    return (
                                                        <ListItem disablePadding sx={{ border: index === currentIndex ? "1px solid #2563EB" : "1px solid #DBEAFE", borderRadius: 2, mb: 3, display: expanded ? (index === currentIndex ? 'block' : 'none') : 'block' }} key={index}>
                                                            <Card sx={{ width: "100%", paddingBottom: "0px" }}>
                                                                <Box>
                                                                    <Box sx={{ height: '8rem', overflow: 'auto' }}>
                                                                        {(editIndex === index || expanded) ? (
                                                                            <TextField
                                                                                fullWidth
                                                                                value={editText || data?.prompt}
                                                                                onChange={(e) => setEditText(e.target.value)}
                                                                                onBlur={() => handleSave(index)}
                                                                                variant="outlined"
                                                                                multiline
                                                                                maxRows={4}
                                                                            />
                                                                        ) : (
                                                                            <Typography
                                                                                variant="body2"
                                                                                color="text.secondary"
                                                                            // onDoubleClick={() => handleEdit(index, data?.prompt)}
                                                                            >
                                                                                {truncateText(data?.prompt)}
                                                                            </Typography>
                                                                        )}
                                                                    </Box>
                                                                </Box>

                                                                <Divider />
                                                                <Box display="flex" justifyContent="flex-end" py={"0.1rem"}>
                                                                    <Box sx={{ display: 'flex' }}>
                                                                        <Box>
                                                                            <IconButton
                                                                                onClick={e => handleDelete(e, index)}
                                                                                color="primary">
                                                                                <Delete />
                                                                            </IconButton>

                                                                            <IconButton
                                                                                sx={{ mx: 1 }}
                                                                                onClick={() => handleToggle(index)}
                                                                                color="primary">
                                                                                {expanded ? <CloseFullscreenIcon /> : <OpenInFull />}
                                                                            </IconButton>

                                                                            <Button
                                                                                variant={expanded ? 'contained' : 'text'}
                                                                                onClick={() => openDialogPublish('createPostWithAI', data)}
                                                                                color="primary">
                                                                                POST
                                                                            </Button>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                            </Card>
                                                        </ListItem>)
                                                })}

                                            </List> : null}
                                        {
                                            expanded ? (
                                                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <IconButton onClick={handlePrev} disabled={currentIndex === 0}>
                                                            <ChevronLeft />
                                                        </IconButton>
                                                        <Typography sx={{ mt: 1 }}>
                                                            {currentIndex + 1}/{content.length}
                                                        </Typography>
                                                        <IconButton onClick={handleNext} disabled={currentIndex === content.length - 1}>
                                                            <ChevronRight />
                                                        </IconButton>
                                                    </Box>
                                                </Box>
                                            ) : null
                                        }
                                    </>
                                    :
                                    <>
                                        <Typography mb={2}>1. Pick a prompt from the left-hand side “Prompt templates” panel, use the button to get a random prompt, or write one from scratch.</Typography>
                                        <Typography mb={2}>2. Write or edit your prompt with what you want the AI to generate and hit the Generate button. </Typography>
                                        <Typography mb={2}>3. Select the results you like and hit the Share on social button. </Typography>
                                    </>
                            }
                        </>
                    }
                </CardContent>
            </Card>
        </Box>
    );
}

export default GeneratedContentComponent;
